import { render, staticRenderFns } from "./station2.vue?vue&type=template&id=45419329&"
import script from "./station2.vue?vue&type=script&lang=js&"
export * from "./station2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports